var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { createUseStyles } from 'react-jss';
import { useTheme } from '../../theme';
import { useMemoClasses } from '../../utils/hooks';
var useStyles = createUseStyles({
    base: {
        display: 'inline',
        color: 'inherit',
        fontSize: '24px',
        margin: '0 calc(0.5 * var(--RUI-margin))',
    },
    baseOverrides: function (theme) { return (__assign({}, theme.overrides.Icon.base)); },
    primary: { color: 'var(--RUI-color-primary)' },
    secondary: { color: 'var(--RUI-color-secondary)' },
    neutral: { color: 'var(--RUI-color-neutral)' },
    error: { color: 'var(--RUI-color-error)' },
    warning: { color: 'var(--RUI-color-warning)' },
    success: { color: 'var(--RUI-color-success)' },
    big: { fontSize: '32px' },
    bigOverrides: function (theme) { return (__assign({}, theme.overrides.Icon.big)); },
    small: { fontSize: '12px' },
    smallOverrides: function (theme) { return (__assign({}, theme.overrides.Icon.small)); },
}, { name: 'RUIIcon' });
var Icon = function (_a) {
    var children = _a.children, size = _a.size, color = _a.color, className = _a.className, props = __rest(_a, ["children", "size", "color", "className"]);
    var theme = useTheme();
    var styles = useStyles(theme);
    var iconClasses = useMemoClasses([
        'material-icons',
        styles.base,
        theme.overrides.Icon.base && styles.baseOverrides,
        color !== 'inherit' && styles[color],
        size !== 'normal' && styles[size],
        size === 'big' && theme.overrides.Icon.big && styles.bigOverrides,
        size === 'small' && theme.overrides.Icon.small && styles.smallOverrides,
        'RUIIcon-base',
        className,
    ], [theme, color, size, className]);
    return (React.createElement("i", __assign({ className: iconClasses, "aria-hidden": true }, props), children));
};
Icon.defaultProps = {
    size: 'normal',
    color: 'inherit',
    children: '',
};
export { Icon as default, Icon };
